import { Foundation } from 'foundation-sites'
import jquery from 'jquery'

window.jQuery = jquery
window.$ = jquery

Foundation.addToJquery($)

jquery(function ($) {
    $(document).foundation()
})

import 'what-input'
import 'motion-ui'


import './js/navigation.js'
import './js/foundation-utils.js';
import './js/animate-on-scroll.js';
import './js/scripts.js';

import './sass/style.scss'